import { useState } from 'react';
import { useGetLinkedObjects } from '../../Core/Hooks/admin/useChat';
import { useSignalRChat } from '../../Core/Hooks/useSignalRChat';
import { ChatRoom, ChatRoomType } from '../../Core/Types/admin/chat';
import { BizObject, ObjectType } from '../../Core/Types/base';
import { BizIcon } from '../../Core/Components/Mini/BizIcon';
import ChatRoomsList from './ChatRoomsList';
import './ChatLinkedObjects.scss';
import { getObjectTypeName } from '../../Core/Utils/objectUtils';
import BizPhrase from '../../../../FrontEnd/Components/Phrase';

type ChatLinkedObjectsProps = {
	onRoomSelect: (room: ChatRoom) => void;
	selectedRoom?: ChatRoom | null;
	chatFuncs: ReturnType<typeof useSignalRChat>;
	onCreateDirectMessageDone: (newRoomId: number) => void;
};

const ChatLinkedObjects = ({ onRoomSelect, selectedRoom, chatFuncs, onCreateDirectMessageDone }: ChatLinkedObjectsProps) => {
	const { data: linkedObjects, statusState: loadingLinkedObjects } = useGetLinkedObjects();
	const [expandedObject, setExpandedObject] = useState<BizObject | null>(null);

	const handleObjectClick = (object: BizObject) => {
		if (expandedObject?.Id === object.Id && expandedObject?.ObjectType === object.ObjectType) {
			setExpandedObject(null);
		} else {
			setExpandedObject(object);
		}
	};

	return (
		<div className='biz-chat-linked-objects'>
			<div className='linked-objects-header'>
				<h4>
					<BizPhrase phraseKey='GLOBAL.CHAT.HEADERS.OBJ_WITH_CHATS'></BizPhrase>
				</h4>
			</div>

			<div className='linked-objects-content'>
				{loadingLinkedObjects === 'LOADING' && (
					<div className='loading'>
						<BizIcon icon='LOADING' /> Loading...
					</div>
				)}

				{/* {linkedObjects && linkedObjects.length === 0 && (
					<div className='no-objects'>No objects with linked chats found.</div>
				)} */}

				{linkedObjects?.map((object) => (
					<div key={`${object.ObjectType}-${object.Id}`} className='linked-object-item'>
						<div
							className={`object-header ${expandedObject?.Id === object.Id && expandedObject?.ObjectType === object.ObjectType ? 'expanded' : ''}`}
							onClick={() => handleObjectClick(object)}
						>
							<div className='object-info'>
								<div className='object-name'>{object.Name}</div>
								<div className='object-type'>{getObjectTypeName(object.ObjectType ?? ObjectType.None)}</div>
							</div>
							<div className='expand-indicator'>
								<BizIcon
									icon={
										expandedObject?.Id === object.Id && expandedObject?.ObjectType === object.ObjectType
											? 'CONTRACT'
											: 'EXPAND'
									}
								/>
							</div>
						</div>

						{expandedObject?.Id === object.Id && expandedObject?.ObjectType === object.ObjectType && (
							<div className='object-chat-rooms'>
								<ChatRoomsList
									onRoomSelect={onRoomSelect}
									selectedRoom={selectedRoom}
									objectType={object.ObjectType}
									objectId={object.Id}
									chatFuncs={chatFuncs}
									onCreateDirectMessageDone={onCreateDirectMessageDone}
									showRoomTypes={[ChatRoomType.DirectMessage]}
								/>
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default ChatLinkedObjects;
